// | ------------------------------------------------------------------------
// | Animate on Scroll
// | ------------------------------------------------------------------------ 


//? https://github.com/michalsnik/aos
import AOS from 'aos'; 


// | ------------------------------------------------------------------------


window.addEventListener('load', (event) => {
    AOS.init();   
});